const features = [
  {
    icon: 'ri-drop-line',
    title: 'Complete Waterproof Integrity',
    desc: '100% waterproof in all weather conditions, ensuring your event stays dry and comfortable regardless of the forecast.',
  },
  {
    icon: 'ri-sun-line',
    title: 'UV Stabilisation',
    desc: 'Treated for enduring brilliance and colour retention, blocking harmful UV rays to protect both guests and the fabric itself.',
  },
  {
    icon: 'ri-fire-line',
    title: 'Fire Retardant',
    desc: 'Fully certified fire retardant assurance, meeting international fire safety standards for peace of mind at every event.',
  },
  {
    icon: 'ri-test-tube-line',
    title: 'Antimicrobial Treatment',
    desc: 'Resists mould, mildew, and bacterial growth, keeping the fabric hygienic and odour-free across repeated deployments.',
  },
  {
    icon: 'ri-expand-left-right-line',
    title: 'Two-Way Stretch',
    desc: 'Unique elasticity allows for multiple rigging configurations and adapts to virtually any structural anchor point.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Durable 3-Ply Construction',
    desc: 'Engineered for long-term performance and repeated use, built to withstand the demands of commercial event rental operations.',
  },
];

export default function FabricFeaturesGrid() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-teal-500 text-sm font-semibold tracking-widest uppercase mb-3">
            Performance Engineered
          </p>
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
            Built for Every Condition
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Every feature of our fabric is designed to deliver superior performance across all environments and event types.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-white rounded-xl p-8 border border-gray-100 hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-50 rounded-xl mb-5">
                <i className={`${feature.icon} text-3xl text-teal-500`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
